import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDesktop,
  faFileCode,
  faPalette,
} from "@fortawesome/free-solid-svg-icons";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import "./services.scss";

const Services = ({ darkMode }) => {
  const [desView, setDesView] = useState(false);
  const [desSecondView, setDesSecondView] = useState(false);
  const [desThirdView, setDesThirdView] = useState(false);
  const [desFourView, setDesFourView] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="Services" className="services">
      <h1 className="py-5" style={{ color: darkMode ? "#f9ab00" : "#191970" }}>
        My Services
      </h1>
      <div className="container">
        <div className="row">
          <div
            className="col-lg-3 col-md-6 col-sm-6"
            style={{ cursor: "pointer" }}
            onClick={() => setDesView(!desView)}
          >
            {desView ? (
              <div className={darkMode ? "box-back" : "box-back-light"}>
                <h3>Web Application</h3>
                <p>
                  We offer customized Web Application with custom features
                  requested by the clients we build the full web application
                  with back end and front end development and maintenance ,
                  hosting , domain for the web application{" "}
                </p>
              </div>
            ) : (
              <div className={darkMode ? "box" : "box-light"}>
                <div className={darkMode ? "circle" : "circle-light"}>
                  <FontAwesomeIcon
                    className="icon"
                    icon={faFileCode}
                    size="2x"
                  />
                </div>
                <h3>Web Application</h3>
                <p>
                  We offer Web Application full developed with Node js and React
                  js with all featured required
                </p>
              </div>
            )}
          </div>
          {/* {} */}
          <div
            className="col-lg-3 col-md-6 col-sm-6"
            style={{ cursor: "pointer" }}
            onClick={() => setDesSecondView(!desSecondView)}
          >
            {desSecondView ? (
              <div className={darkMode ? "box-back" : "box-back-light"}>
                <h3>Landing pages</h3>
                <p>
                  We offer landing pages converting Xd , Figma , Psd design into
                  Html and Css , javascript also its possible to use frameworks
                  like React js or Bootstrap , for styling optional to use Css
                  or Scss converting the design with perfect pixel
                </p>
              </div>
            ) : (
              <div className={darkMode ? "box" : "box-light"}>
                <div className={darkMode ? "circle" : "circle-light"}>
                  <FontAwesomeIcon
                    className="icon"
                    icon={faPalette}
                    size="2x"
                  />
                </div>
                <h3>Landing pages</h3>
                <p>
                  We offer landing pages for any type of website builded with
                  perfect pixel user friendly and professional
                </p>
              </div>
            )}
          </div>
          {/* {} */}
          <div
            className="col-lg-3 col-md-6 col-sm-6"
            style={{ cursor: "pointer" }}
            onClick={() => setDesThirdView(!desThirdView)}
          >
            {desThirdView ? (
              <div className={darkMode ? "box-back" : "box-back-light"}>
                <h3>Business website</h3>
                <p>
                  We offer website for your business with customized design and
                  features including domain , hosting and maintenance for the
                  website
                </p>
              </div>
            ) : (
              <div className={darkMode ? "box" : "box-light"}>
                <div className={darkMode ? "circle" : "circle-light"}>
                  <FontAwesomeIcon className="icon" icon={faGoogle} size="2x" />
                </div>
                <h3>Business website</h3>
                <p>
                  We offer website for your business with all features required
                  and maintenance for the website
                </p>
              </div>
            )}
          </div>
          <div
            className="col-lg-3 col-md-6 col-sm-6"
            style={{ cursor: "pointer" }}
            onClick={() => setDesFourView(!desFourView)}
          >
            {desFourView ? (
              <div className={darkMode ? "box-back" : "box-back-light"}>
                <h3>Web Design</h3>
                <p>
                  We offer user friendly and professional for full websites ,
                  landing page or web application , with professional and user
                  firendly design witch can be build in Figma , Xd , Psd
                  optional to clients
                </p>
              </div>
            ) : (
              <div className={darkMode ? "box" : "box-light"}>
                <div className={darkMode ? "circle" : "circle-light"}>
                  <FontAwesomeIcon
                    className="icon"
                    icon={faDesktop}
                    size="2x"
                  />
                </div>
                <h3>Web Design</h3>
                <p>
                  We offer user friendly and professional web designs for any
                  types of websites
                </p>
              </div>
            )}
          </div>
          {/* {} */}
        </div>
      </div>
    </div>
  );
};

export default Services;
